import { render } from "./SurveyNavbar.vue?vue&type=template&id=38aeb418&scoped=true"
import script from "./SurveyNavbar.vue?vue&type=script&lang=js"
export * from "./SurveyNavbar.vue?vue&type=script&lang=js"

import "./SurveyNavbar.vue?vue&type=style&index=0&id=38aeb418&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/epr-survey-builder/Vue_Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38aeb418"]])

export default __exports__